import React, { Component } from 'react';
import './css/footer.css'; // Asegúrate de que esta ruta esté correcta
import i18n from './I18N/I18n.js'; 

const Footer = () => {

    return (
      <footer className="custom-footer">
      <div className="custom-footer-social">
        <a href="#" className="custom-social-link"> {/* Aquí puedes agregar iconos si los tienes */} </a>
        <a href="#" className="custom-social-link"></a>
      </div>
    
      <div className="custom-footer-links">
        <a href="mailto:juan.ayensa@certifica-t.app?subject=Incidencia con Certifica-t.app" className="custom-footer-link">
          {i18n.t('soporte')}
        </a>
        <a href="/terminosYcondiciones" className="custom-footer-link">
          {i18n.t('termsf')}
        </a>
      </div>
    
      <p className="custom-footer-copyright">{i18n.t('rightsReserved')}</p>
    </footer>
    );
  }

export default Footer;
